import ForecastRepository from './ForecastRepository';

export default class ForecastService {
  private forecastRepository: ForecastRepository = new ForecastRepository();

  async postParameterPastForecast(
    parameterId: string | number,
    dateFrom: string | null = null,
    dateTo: string | null = null,
    simulationId: string | null = null,
  ): Promise<any> {
    return this.forecastRepository.postParameterPastForecast(
      parameterId,
      dateFrom,
      dateTo,
      simulationId,
    );
  }
}
